import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ShowListComponent from '../../../Components/ShowComponent/ShowListComponent';

const ShowList = (props) => {
    let navigate = useNavigate();
    const params = useParams();

    return (
        <div>
            <ShowListComponent {...props} navigate={navigate} id={params.id} />
        </div>
    );
}

export default ShowList